export enum SubMenu {
  PENDING = 'pending',
  ON_PROGRESS = 'onprogress',
  HISTORY = 'history',
}

export enum StatusTitleLabel {
  PENDING = 'Menunggu Konfirmasi',
  CREATED = 'Butuh Diproses',
  REQUEST = 'Request',
  CANCELLATION_REQUEST = 'Pengajuan Pembatalan', // Pengajuan Cancel SPM
  ON_PROGRESS = 'Dalam Proses Scan',
  PARTIAL_COMPLETED = 'Selesai Sebagian',
  FINISH = 'Histori',
  EXPIRED = 'Histori',
  CANCEL = 'Histori',
  READY_TO_DELIVERY = 'Siap dikirim',
}

export enum StatusSPMLabel {
  PENDING = 'Menunggu Konfirmasi',
  CREATED = 'Butuh Diproses',
  // REQUEST = 'Request',
  ON_PROGRESS = 'Dalam Proses Scan',
  PARTIAL_COMPLETED = 'Selesai Sebagian',
  FINISH = 'Selesai',
  EXPIRED = 'Histori',
  CANCEL = 'Dibatalkan',
}

export enum StatusSPMFilter {
  PENDING = 'Menunggu Konfirmasi Pusat',
  CREATED = 'Butuh Diproses',
  ON_PROGRESS = 'Dalam Proses Scan',
  PARTIAL_COMPLETED = 'Selesai Sebagian',
  FINISH = 'Selesai',
  EXPIRED = 'Kadaluarsa',
  READY_TO_DELIVERY = 'Siap dikirim',
  CANCELLATION_REQUEST = 'Permintaan pembatalan',
  CANCEL = 'Dibatalkan',
}

export enum StatusSPM {
  CREATED = 'CREATED',
  CANCELLATION_REQUEST = 'CANCELLATION_REQUEST', // Pengajuan Cancel SPM
  REQUEST = 'REQUEST',
  PENDING = 'PENDING',
  ON_PROGRESS = 'ON_PROGRESS',
  PARTIAL_COMPLETED = 'PARTIAL_COMPLETED', // SELESAI SEBAGIAN
  FINISH = 'FINISH', // SELESAI
  EXPIRED = 'EXPIRED', // KADALUARSA
  CANCEL = 'CANCEL', // DIBATALKAN
  READY_TO_DELIVERY = 'READY_TO_DELIVERY',
}

export enum StatusPath {
  PENDING = 'waiting-confirmation',
  CREATED = 'created',
  CANCELLATION_REQUEST = 'cancellation-request', // Pengajuan Cancel SPM
  REQUEST = 'request',
  ON_PROGRESS = 'pending',
  PARTIAL_COMPLETED = 'history',
  FINISH = 'history',
  EXPIRED = 'expired',
  CANCEL = 'cancel',
  READY_TO_DELIVERY = 'ready-to-delivery',
}
